import Input from './Input';
import PreventAutocomplete from './InputPreventAutocomplete';

export default Input;
export const InputPreventAutocomplete = PreventAutocomplete;
